import { i18n } from '@/i18n'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('distributors.header'),
      path: 'configurations/distributors',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/distributors/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('clients.modules'),
          path: 'configurations/distributors/modules',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.locations_hired'),
          path: 'configurations/distributors/locations',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('distributors.template_clients'),
          path: 'configurations/distributors/template/clients',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('distributors.template_clients_personalization'),
          path: 'configurations/distributors/template/clientspersonalization',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('distributors.template_clients_horario_descarga'),
          path: 'configurations/distributors/template/clientsdownloadschedule',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('distributors.template_clients_calendario_festivos'),
          path: 'configurations/distributors/template/clientsholidaycalendar',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.historical'),
          path: 'configurations/distributors/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
